<template>
    <div class="vip-box">
        <div class="page-title flex flex-space-between">
            <span>唯品会授权</span>
            
            <div>
                <button class="btn btn-white" @click="gotoAuth">添加授权</button>
            </div>
        </div>
        
        <pay-box title="授权说明">
            <div class="tips-img-box">
                <a class="tips-img" href="https://passport.vip.com/register" target="_blank">
                    <img src="https://static.ycsd.work/col/vip-tips1.png" alt="">
                </a>
                <a class="tips-img" @click="tipsClicked">
                    <img src="https://static.ycsd.work/col/vip-tips2.png" alt="">
                </a>
            </div>
        </pay-box>
        
        <pay-box title="授权信息">
            <a-spin :spinning="loading">
                <table class="vip-table ">
                    <thead>
                    <tr>
                        <th>授权ID</th>
                        <th>到期时间</th>
                        <th>管理</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!loading && !vipList.length">
                        <td colspan="3" class="text-center">
                            <span>暂无唯品会授权信息..., </span>
                            <a @click="gotoAuth">点击添加授权</a>
                        </td>
                    </tr>
                    <template v-for="item in vipList">
                        <tr :key="item.id">
                            <td>{{ item.open_id }}</td>
                            <td>{{ $formatTime(item.refresh_expires_time * 1000) }}</td>
                            <td>
                                <button class="btn btn-white" @click="gotoAuth">刷新授权</button>
                                <button class="btn btn-white" v-if="item.is_default">默认</button>
                                <button class="btn btn-white" v-else @click="setDefault(item)">设置默认</button>
                                <button class="btn btn-danger outline" @click="deleteAuth(item)">删除</button>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </a-spin>
        </pay-box>
        
        <div class="clearfix"></div>
    </div>
</template>
<script>

import PayBox from "@/views/AST/Pay/Step/PayBox.vue";
import api from "@/repo/api";

export default {
    name: 'Vip',
    components: {PayBox},
    data() {
        return {
            vipList: [],
            loading: true,
        }
    },
    mounted() {
        this.getAuthList();
    },
    methods: {
        tipsClicked() {
        
        },
        gotoAuth() {
            this.$confirm({
                title: "需要前往唯品会授权页面吗？",
                onOk: () => {
                    this.fetchAuthUrl();
                }
            })
        },
        getAuthList() {
            this.loading = true;
            
            api.get('/ast-vip/auth-list').then(res => {
                this.vipList = res.data || [];
                this.loading = false;
            })
        },
        deleteAuth(item) {
            this.$confirm({
                title: "确定删除该授权吗？",
                onOk: () => {
                    api.post('/ast-vip/delete-auth', {id: item.id}).then(res => {
                        if (res.code !== 0) {
                            this.$message.error(res.msg);
                            return;
                        }
                        
                        this.$message.success("删除成功");
                        this.getAuthList();
                    })
                }
            })
        },
        setDefault(item) {
            
            if (item.is_default) return;
            
            this.$loading.show()
            
            api.post('/ast-vip/set-default', {id: item.id}).then(res => {
                
                this.$loading.hide();
                
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                    return;
                }
                
                this.$message.success("设置成功");
                this.getAuthList();
            })
        },
        fetchAuthUrl() {
            this.$loading.show()
            
            api.get('/ast-vip/auth-url').then(res => {
                
                this.$loading.hide();
                
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                    return;
                }
                
                window.location.href = res.data.auth_url;
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.vip-box {
    width: 1008px;
}

.tips-img-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.tips-img {
    user-select: none;
    cursor: pointer;
    width: 460px;
    
    img {
        width: 100%;
        user-select: none;
        pointer-events: none;
    }
}


.vip-table {
    width: 100%;
    
    th {
        font-size: 14px;
        color: #999999;
        line-height: 16px;
        text-align: left;
        font-weight: 400;
        padding-bottom: 28px;
        border-bottom: 1px solid #EEEEEE;
    }
    
    tbody {
        tr td {
            padding-top: 20px;
        }
        
        tr:first-child td {
            padding-top: 12px;
        }
    }
    
    .btn {
        margin-right: 16px;
    }
}
</style>
